import { z } from 'zod';
import { getFullChatResponseSchema } from '../getFullChatResponseSchema';

export const chatsControllerGetByQueryParamsSchema = z
  .object({
    page: z.number().int().min(1).default(1).optional(),
    take: z.number().int().min(1).default(10).optional(),
    status: z
      .union([
        z.array(z.enum(['pending', 'open', 'closed'])),
        z.enum(['pending', 'open', 'closed']),
      ])
      .optional(),
    creatorId: z.string().uuid().optional(),
  })
  .optional();

export const chatsControllerGetBy200Schema = z.lazy(
  () => getFullChatResponseSchema,
);

export const chatsControllerGetBy400Schema = z.object({
  statusCode: z.enum(['400']),
  message: z.string(),
  type: z.enum(['InvalidData']),
  details: z.object({
    location: z.enum(['path', 'query', 'body']),
    explanation: z.object({
      issues: z.array(
        z
          .object({
            code: z.enum([
              'invalid_type',
              'invalid_literal',
              'custom',
              'invalid_union',
              'invalid_union_discriminator',
              'invalid_enum_value',
              'unrecognized_keys',
              'invalid_arguments',
              'invalid_return_type',
              'invalid_date',
              'invalid_string',
              'too_small',
              'too_big',
              'invalid_intersection_types',
              'not_multiple_of',
              'not_finite',
            ]),
            path: z.array(z.union([z.string(), z.number()])),
            message: z.string(),
          })
          .catchall(z.unknown()),
      ),
    }),
  }),
});

export const chatsControllerGetBy401Schema = z.object({
  statusCode: z.enum(['401']),
  message: z.string(),
  type: z.enum(['Authentication']),
  details: z.object({
    reason: z.enum(['InvalidRequest', 'InvalidToken', 'Unauthorized']),
  }),
});

export const chatsControllerGetBy403Schema = z.object({
  statusCode: z.enum(['403']),
  message: z.string(),
  type: z.enum(['Authorization']),
  details: z.object({ reason: z.enum(['InsufficientScope']) }),
});

export const chatsControllerGetByQueryResponseSchema = z.lazy(
  () => getFullChatResponseSchema,
);
